import React, { createContext, useState, useContext, useEffect } from "react";

const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);
  const [propertyName, setPropertyName] = useState("");
  const [propertyTimezone, setPropertyTimezone] = useState("");
  const [propertyChats, setPropertyChats] = useState("");

  useEffect(() => {
    // Load the initial state from local storage
    const storedPropertyId = localStorage.getItem("selectedPropertyId");
    if (storedPropertyId) {
      setSelectedPropertyId(storedPropertyId);
    }
  }, []);

  const selectProperty = (propertyId) => {
    setSelectedPropertyId(propertyId);
    localStorage.setItem("selectedPropertyId", propertyId);
  };

  const clearProperty = () => {
    setSelectedPropertyId(null);
    localStorage.removeItem("selectedPropertyId");
  };

  return (
    <PropertyContext.Provider
      value={{
        selectedPropertyId,
        selectProperty,
        clearProperty,
        setPropertyTimezone,
        setPropertyName,
        propertyTimezone,
        propertyName,
        propertyChats,
        setPropertyChats,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const useProperty = () => useContext(PropertyContext);
